import React from 'react';
import './BrandSearchSkeleton.css';

const BrandSearchSkeleton: React.FC = () => {
  return (
    <div className="brands-skeleton">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="brand-item-skeleton">
          <div className="brand-avatar-skeleton pulse" />
          <div className="brand-content-skeleton">
            <div className="brand-name-skeleton pulse" />
          </div>
          <div className="brand-button-skeleton pulse" />
        </div>
      ))}
    </div>
  );
};

export default BrandSearchSkeleton; 